import { MNEMONICS } from 'constants/mnemonics';
import { MnemonicsMappingDTO } from 'types/mnemonicsMapping';
import { OFFSHORE_SUBSEA, OFFSHORE_SURFACE } from 'types/wellbore';

const getFlowoutNA = (
  searchedFlowout: string,
  otherFlowout: string,
  mnemonicsMapping?: MnemonicsMappingDTO,
) => {
  const mapping = mnemonicsMapping?.timeData;
  if (!mapping || !mapping[otherFlowout]) return false;

  return (
    mapping[otherFlowout].live && (!mapping[searchedFlowout] || !mapping[searchedFlowout].live)
  );
};

// getFlowoutsNA sets booleans that change the display of the mnemonicsMappingTable
// the goal is to determine if the absence of data should be interpreted as a faulty sensor/mnemonic
// or if the mnemonic is simply not available due to the configuration of the well.
// For example Onshore rigs cannot have a Flow In Booster value.
// FlowoutAVNA => Flow Out Average Not Applicable
// FlowoutPCNA => Flow Out Percentage Not Applicable
// FlowinBstNA => Flow In Booster Not Applicable

export const getFlowoutsNA = (locationType?: string, mnemonicsMapping?: MnemonicsMappingDTO) => {
  const isFlowOutAVNA = getFlowoutNA(MNEMONICS.FLOWOUTAV, MNEMONICS.FLOWOUTPC, mnemonicsMapping);
  const isFlowOutPCNA = getFlowoutNA(MNEMONICS.FLOWOUTPC, MNEMONICS.FLOWOUTAV, mnemonicsMapping);
  const isFlowInBstNA =
    (locationType !== OFFSHORE_SURFACE && locationType !== OFFSHORE_SUBSEA) ||
    (locationType === OFFSHORE_SURFACE &&
      (!mnemonicsMapping?.timeData?.MDSBP || !mnemonicsMapping.timeData.MPDSBP.live));

  return { isFlowOutAVNA, isFlowOutPCNA, isFlowInBstNA };
};
